import { push, replace } from 'connected-react-router';

const routeTo = (route, type = 'push', rest) => (dispatch, getState) => {
  const {
    router: {
      location: { search }
    }
  } = getState();

  const func = type === 'push' ? push : replace;

  return dispatch(func({ pathname: route, search, ...rest }));
};

export default routeTo;
